import { useMsgServer, useRoomBaseServer, useUserServer } from 'middle-domain';
import { hideFavicon } from '@/app-shared/utils/common';
export const getSubscribeConfigs = async function () {
  const roomBaseServer = useRoomBaseServer();
  const userServer = useUserServer();
  const promiseList = [
    //多语言接口
    // roomBaseServer.getLangList(),
    // 调用聚合接口
    roomBaseServer.getCommonConfig({
      tags: [
        'skin',
        'screen-poster',
        'public-account',
        'webinar-tag',
        'menu',
        'adv-default',
        'invite-card',
        'timer'
      ]
    }),
    roomBaseServer.getConfigList({ scene_id: 3 })
  ];
  if (window.sessionStorage.getItem('token')) {
    promiseList.push(userServer.getUserInfo({ scene_id: 2 }));
  }
  await Promise.all(promiseList);
};
export default async function () {
  console.log('%c------服务初始化 开始', 'color:blue');
  const roomBaseServer = useRoomBaseServer();
  const msgServer = useMsgServer();
  const userServer = useUserServer();

  const configList = roomBaseServer.state.configList;
  !configList['ui.hide_favicon'] && hideFavicon();

  msgServer.initMaintMsg({
    hide: 1
  });
  console.log('%c------服务初始化 msgServer 初始化完成', 'color:blue');
}
